import React, { Component } from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "formik";
import { withRouter } from "react-router-dom";
import WorkflowProgressTracker from "./WorkflowProgressTracker";
import { Consumer as WorkflowConsumer } from "./context";

const styles = theme => ({
  progressBar: {
    [theme.breakpoints.down("sm")]: {
      height: theme.spacing(1)
    },
    [theme.breakpoints.up("md")]: {
      height: theme.spacing(2)
    },
    borderRadius: theme.shape.borderRadius
  },
  label: {
    transform: "scale(0.85)"
  },
  button: {
    height: "100%"
  },
  avatar: {
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing(2)
  }
});

class WorkflowTopNav extends Component {
  shouldComponentUpdate = nextProps =>
    nextProps.location.pathname !== this.props.location.pathname ||
    nextProps.formik.submitForm !== this.props.formik.submitForm ||
    nextProps.classes !== this.props.classes ||
    nextProps.hideButtons !== this.props.hideButtons ||
    nextProps.hideProgress !== this.props.hideProgress ||
    nextProps.hideLabel !== this.props.hideLabel;

  render = () => {
    const { formik, classes, hideButtons, hideProgress } = this.props;
    return (
      <WorkflowConsumer>
        {({ getActiveStep, goBack }) => {
          const [activeStepKey, activeStep] = getActiveStep(true);
          if (!activeStep) return null;

          const prevButton = !hideButtons ? (
            <Box alignSelf="stretch">
              <Button
                onClick={goBack(formik)}
                color="inherit"
                disabled={activeStep.prev === undefined}
                classes={{ root: classes.button }}
              >
                <KeyboardArrowLeft />
                Back
              </Button>
            </Box>
          ) : null;

          const nextButton = !hideButtons ? (
            <Box alignSelf="stretch">
              <Button
                onClick={formik.submitForm}
                color="inherit"
                disabled={activeStep.next === undefined}
                classes={{ root: classes.button }}
              >
                Next
                <KeyboardArrowRight />
              </Button>
            </Box>
          ) : null;

          const progress =
            hideProgress || activeStep.progress === undefined ? null : (
              <LinearProgress
                color="secondary"
                key="progress"
                value={activeStep.progress}
                variant="determinate"
                classes={{ root: classes.progressBar }}
              />
            );

          return (
            <Box
              width="100%"
              display="flex"
              alignItems="center"
              justify="space-between"
            >
              {prevButton}
              <Box flexGrow={1} mr={2} ml={2}>
                <Hidden smUp implementation="css">
                  <Typography
                    component="div"
                    variant="body2"
                    align="center"
                    className={classes.label}
                  >
                    {activeStep.label || activeStepKey}
                  </Typography>
                  {progress}
                </Hidden>
                <Hidden xsDown implementation="css">
                  <WorkflowProgressTracker
                    orientation="horizontal"
                    alternativeLabel
                  />
                </Hidden>
              </Box>
              {nextButton}
            </Box>
          );
        }}
      </WorkflowConsumer>
    );
  };
}

export default withStyles(styles, { name: "LcWorkflowTopNav" })(
  withRouter(connect(WorkflowTopNav))
);
